import { PermissionNumber } from '@person/user/self/data-access';

export interface DxPermissionGuardConfig {
  permissions: PermissionNumber[];
  translationKey: string;
}

export const DX_PERMISSION_GUARD_CONFIG_TOKEN = Symbol('DX_PERMISSION_GUARD_CONFIG_TOKEN');
